<!--todo  -->
<template>
  <div v-if="showAuditSection">
    <!-- <div class="split-line"></div> -->
    <h3>审方</h3>
    <div class="audit-matrix">
      <template v-if="showPharmacistPreAudit">
        <div class="audit-matrix__row">
          <span class="audit-matrix__cell">{{ prescriptionDetail.pharmacistAuditTimeStr }}</span>
          <span class="audit-matrix__cell">一审药师 {{ prescriptionDetail.pharmacistAuditName || '-' }}</span>
          <span class="audit-matrix__cell">{{ preAuditStatusText }}</span>
          <span class="audit-matrix__cell audit-matrix__remark">{{ preAuditRemarkDisplay }}</span>
        </div>
      </template>
      <template v-if="prescriptionDetail.prescriptionAuditTimeStr">
        <div class="audit-matrix__row">
          <span class="audit-matrix__cell">{{ prescriptionDetail.prescriptionAuditTimeStr }}</span>
          <span class="audit-matrix__cell">二审药师 {{ prescriptionDetail.prescriptionAuditorName || '-' }}</span>
          <span class="audit-matrix__cell">
            {{ prescriptionDetail.prescriptionAuditorStatus | parsePrescriptionStatus }}
          </span>
          <span class="audit-matrix__cell audit-matrix__remark">{{ auditorMemoDisplay }}</span>
        </div>
      </template>
    </div>

    <!--    <el-row v-if="prescriptionDetail.prescriptionReauditTime">-->
    <!--      <el-col :span="24">-->
    <!--        <span>-->
    <!--          {{ prescriptionDetail.prescriptionReauditTime | parseTime }}&nbsp;&nbsp;&nbsp;&nbsp;{{-->
    <!--            prescriptionDetail.prescriptionReauditorName-->
    <!--          }}&nbsp;&nbsp;&nbsp;&nbsp;{{-->
    <!--            prescriptionDetail.prescriptionReauditorStatus | parsePrescriptionStatus-->
    <!--          }}&nbsp;&nbsp;&nbsp;&nbsp;备注:{{ prescriptionDetail.prescriptionReauditorMemo }}-->
    <!--        </span>-->
    <!--      </el-col>-->
    <!--    </el-row>-->
  </div>
</template>

<script>
export default {
  name: 'prescriptionAudit',
  props: {
    prescriptionDetail: {}
  },
  computed: {
    showPharmacistPreAudit() {
      const d = this.prescriptionDetail || {};
      const hasTime = d.pharmacistAuditTimeStr != null && String(d.pharmacistAuditTimeStr).trim() !== '';
      const hasStatus = d.preAuditStatus !== undefined && d.preAuditStatus !== null;
      const hasRemark = d.preAuditRemark != null && String(d.preAuditRemark).trim() !== '';
      return hasTime || hasStatus || hasRemark;
    },
    showAuditSection() {
      return this.showPharmacistPreAudit || !!this.prescriptionDetail.prescriptionAuditTimeStr;
    },
    preAuditStatusText() {
      const map = { 0: '待确认', 1: '已通过', 2: '已驳回' };
      const s = this.prescriptionDetail.preAuditStatus;
      return map[s] != null ? map[s] : '-';
    },
    hasPreAuditRemark() {
      const r = (this.prescriptionDetail || {}).preAuditRemark;
      return r != null && String(r).trim() !== '';
    },
    hasPrescriptionAuditorMemo() {
      const r = (this.prescriptionDetail || {}).prescriptionAuditorMemo;
      return r != null && String(r).trim() !== '';
    },
    /** 占位保证与二审行第四列对齐；有内容时才带「备注:」 */
    preAuditRemarkDisplay() {
      return this.hasPreAuditRemark ? `备注:${this.prescriptionDetail.preAuditRemark}` : '';
    },
    auditorMemoDisplay() {
      return this.hasPrescriptionAuditorMemo ? `备注:${this.prescriptionDetail.prescriptionAuditorMemo}` : '';
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
/* 两行共用列宽，保证时间 / 药师 / 状态 / 备注上下对齐 */
.audit-matrix {
  display: grid;
  grid-template-columns: max-content max-content max-content minmax(0, 1fr);
  column-gap: 24px;
  row-gap: 10px;
  align-items: baseline;
  font-size: 14px;
  line-height: 1.5;
  color: #707070;
}

.audit-matrix__row {
  display: contents;
}

.audit-matrix__cell {
  min-width: 0;

  &:nth-child(4n + 1),
  &:nth-child(4n + 2),
  &:nth-child(4n + 3) {
    white-space: nowrap;
  }
}

.audit-matrix__remark {
  white-space: normal;
  word-break: break-word;
}
</style>
